// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_PRINTING_DC_REQUEST_DK = 'FETCH_PRINTING_DC_REQUEST_DK';
export const FETCH_PRINTING_DC_SUCCESS_DK = 'FETCH_PRINTING_DC_SUCCESS_DK';
export const FETCH_PRINTING_DC_FAILURE_DK = 'FETCH_PRINTING_DC_FAILURE_DK';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_PRINTING_DC_REQUEST_DK = 'CREATE_PRINTING_DC_REQUEST_DK';
export const CREATE_PRINTING_DC_SUCCESS_DK = 'CREATE_PRINTING_DC_SUCCESS_DK';
export const CREATE_PRINTING_DC_FAILURE_DK = 'CREATE_PRINTING_DC_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_PRINTING_DC_DK = 'CREATE_USER_FORM_PRINTING_DC_DK';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_PRINTING_DC_REQUEST_DK = 'UPDATE_PRINTING_DC_REQUEST_DK';
export const UPDATE_PRINTING_DC_SUCCESS_DK = 'UPDATE_PRINTING_DC_SUCCESS_DK';
export const UPDATE_PRINTING_DC_FAILURE_DK = 'UPDATE_PRINTING_DC_FAILURE_DK';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_PRINTING_DC_REQUEST_DK = 'FETCH_SINGLE_PRINTING_DC_REQUEST_DK';
export const FETCH_SINGLE_PRINTING_DC_SUCCESS_DK = 'FETCH_SINGLE_PRINTING_DC_SUCCESS_DK';
export const FETCH_SINGLE_PRINTING_DC_FAILURE_DK = 'FETCH_SINGLE_PRINTING_DC_FAILURE_DK';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_PRINTING_DC_REQUEST_DK = 'DELETE_PRINTING_DC_REQUEST_DK';
export const DELETE_PRINTING_DC_SUCCESS_DK = 'DELETE_PRINTING_DC_SUCCESS_DK';
export const DELETE_PRINTING_DC_FAILURE_DK = 'DELETE_PRINTING_DC_FAILURE_DK';

// USERFORM RESET

export const PRINTING_DC_USERFORM_RESET_DK = 'PRINTING_DC_USERFORM_RESET_DK';

// navigate to unit component
export const NAVIGATE_PRINTING_DC_DETAILS_DK = 'NAVIGATE_PRINTING_DC_DETAILS_DK';
// navigate to company component
export const NAVIGATE_PRINTING_DC_DK = 'NAVIGATE_PRINTING_DC_DK';
export const PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK = 'PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK';
export const PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK = 'PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK';

export const FETCH_PRINTING_DC_STYLE_REQUEST_DK = 'FETCH_PRINTING_DC_STYLE_REQUEST_DK';
export const FETCH_PRINTING_DC_STYLE_SUCCESS_DK = 'FETCH_PRINTING_DC_STYLE_SUCCESS_DK';
export const FETCH_PRINTING_DC_STYLE_FAILURE_DK = 'FETCH_PRINTING_DC_STYLE_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_PRINTING_DC_INVOICE_REQUEST_DK = 'FETCH_PRINTING_DC_INVOICE_REQUEST_DK';
export const FETCH_PRINTING_DC_INVOICE_SUCCESS_DK = 'FETCH_PRINTING_DC_INVOICE_SUCCESS_DK';
export const FETCH_PRINTING_DC_INVOICE_FAILURE_DK = 'FETCH_PRINTING_DC_INVOICE_FAILURE_DK';

export const RESET_PRINTING_DC_INVOICE_DK = 'RESET_PRINTING_DC_INVOICE_DK';


export const DELETE_BTN_UPDATE_API_REQUEST_DK = 'DELETE_BTN_UPDATE_API_REQUEST_DK';
export const DELETE_BTN_UPDATE_API_SUCCESS_DK = 'DELETE_BTN_UPDATE_API_SUCCESS_DK';
export const DELETE_BTN_UPDATE_API_FAILURE_DK = 'DELETE_BTN_UPDATE_API_FAILURE_DK';